var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __spread = this && this.__spread || function () {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(__read(arguments[i]));
  }

  return ar;
};

import React, { Component } from 'react';
import { Line, Bar } from 'react-chartjs-2';
import { Button } from '@cimpress/react-components';
import { fetchHeaders, chartColors, emptyChart } from './chartUtils';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import '../../styles/PricingGridChart.css';
import '../../styles/charts.css';
import 'chartjs-plugin-zoom';
import { capitalize } from '../../utils/utils';

var PricingGridChart =
/** @class */
function (_super) {
  __extends(PricingGridChart, _super);

  function PricingGridChart(props) {
    var _this = _super.call(this, props) || this;

    _this.getInitialState = function () {
      return {
        chartData: null,
        contracts: null,
        initialContract: null,
        maximumPrice: 0
      };
    };

    _this.populateGraphData = function () {
      var _a = _this.props,
          gridData = _a.gridData,
          headers = _a.headers,
          pivotKeyRow = _a.pivotKeyRow,
          pivotKeyColumn = _a.pivotKeyColumn,
          selectedContract = _a.selectedContract;
      var maximumPrice = _this.state.maximumPrice;
      var colors = Object.values(chartColors);
      var labels = [];
      var datasets = {};

      if (!gridData || !headers) {
        return null;
      }

      var colorIndex = -1;
      headers.forEach(function (columndDef) {
        if (columndDef.headerName !== pivotKeyRow) {
          var result = fetchHeaders(columndDef);
          result.forEach(function (header) {
            if (header) {
              colorIndex += 1;
              var label = header.split('|').filter(function (head) {
                return head !== '';
              }).pop();
              datasets[header.toLowerCase()] = {
                label: capitalize(label),
                backgroundColor: colors[colorIndex % 12],
                borderColor: colors[colorIndex % 12],
                data: [],
                spanGaps: true,
                currency: [],
                borderWidth: '1',
                fill: false
              };
            }
          });
        }
      });
      colorIndex = -1;
      var contracts = [];
      var resultByContract = {};
      gridData.forEach(function (row) {
        var keys = Object.keys(row); // If data is available in row

        if (keys.length > 1) {
          keys.forEach(function (data) {
            if (data.toLowerCase() === pivotKeyRow.toLowerCase()) {
              labels.push(row[data]);
            } else {
              var displayPrice = row[data].productPrice && row[data].productPrice.displayPrice || undefined;
              var currency = row[data].productPrice && row[data].productPrice.currency || undefined;
              maximumPrice = Math.max(parseInt(displayPrice, 10), maximumPrice);

              _this.insertPrices(data, datasets, pivotKeyColumn, resultByContract, contracts, displayPrice, currency, colorIndex);

              colorIndex += 1;
            }
          });
        }
      });

      var sortedContracts = _this.sortContracts(contracts);

      contracts = __spread(sortedContracts.CatalogPrice, sortedContracts.Contracts);
      var initialContract = null;
      datasets = Object.values(datasets);
      var chartData = null;

      if (pivotKeyColumn && contracts[0]) {
        initialContract = selectedContract || contracts[0];

        if (!selectedContract) {
          _this.props.changeSelectedContract(initialContract);
        }

        var data = _this.clearEmptyDatasets(Object.values(resultByContract[contracts[0]]));

        chartData = {
          labels: labels,
          datasets: data
        };
      } else {
        // Added this function to filter empty dataset and when attributes are reset.
        datasets = _this.clearEmptyDatasets(datasets);
        chartData = {
          labels: labels,
          datasets: datasets
        };
      }

      _this.setState({
        chartData: chartData,
        contracts: sortedContracts,
        resultByContract: resultByContract,
        initialContract: initialContract,
        maximumPrice: maximumPrice
      });

      return null;
    };

    _this.clearEmptyDatasets = function (datasets) {
      var newDataSets = [];
      datasets.forEach(function (dataset) {
        if (dataset.data.length > 0) {
          var flag = false;
          var data = dataset.data;
          var noOfDataPoints = data.length;

          for (var i = 0; i < noOfDataPoints; i++) {
            if (data[i]) {
              flag = true;
              break;
            }
          }

          if (flag) {
            newDataSets.push(dataset);
          }
        }
      });
      return newDataSets;
    };

    _this.insertPrices = function (data, datasets, pivotKeyColumn, resultByContract, contracts, displayPrice, currency, colorIndex) {
      if (datasets[data.toLowerCase()]) {
        datasets[data.toLowerCase()].data.push(displayPrice);
        datasets[data.toLowerCase()].currency.push(currency);
      } else {
        return null;
      }

      if (pivotKeyColumn) {
        var colors = Object.values(chartColors);
        var header = data.split('|').filter(function (head) {
          return head !== '';
        });
        var pivotColumn = header.pop();
        var contractName = header.pop();
        var contractType = header.pop();

        if (!resultByContract[contractName]) {
          resultByContract[contractName] = {};
          contracts.push({
            type: contractType,
            label: contractName
          });
        }

        if (!resultByContract[contractName][pivotColumn]) {
          colorIndex += 1;
          resultByContract[contractName][pivotColumn] = {
            label: pivotColumn,
            backgroundColor: colors[colorIndex % 12],
            borderColor: colors[colorIndex % 12],
            borderWidth: '1',
            data: [],
            currency: [],
            fill: false
          };
        } // resultByContract[contractName].key.push(pivotColumn);


        resultByContract[contractName][pivotColumn].data.push(displayPrice);
        resultByContract[contractName][pivotColumn].currency.push(currency);
      }

      return null;
    };

    _this.sortContracts = function (contracts) {
      var filteredContracts = {
        CatalogPrice: [],
        Contracts: []
      };
      contracts.forEach(function (contract) {
        if (contract.type === 'Catalog Price') {
          filteredContracts.CatalogPrice.push(contract.label);
        } else {
          filteredContracts.Contracts.push(contract.label);
        }
      });
      return filteredContracts;
    };

    _this.changeDisplayedContract = function (contract) {
      var chartData = _this.state.chartData;
      var resultByContract = _this.state.resultByContract;
      var labels = chartData.labels;
      var updatedResult = resultByContract[contract];
      updatedResult = _this.clearEmptyDatasets(Object.values(updatedResult));
      chartData = {
        labels: labels,
        datasets: updatedResult
      };

      _this.setState({
        chartData: chartData
      });
    };

    _this.onContractChange = function (event) {
      _this.props.changeSelectedContract(event.target.value);

      _this.changeDisplayedContract(event.target.value);
    };

    _this.onChartTypeChange = function (event) {
      _this.props.changePricingGridChartType(event.target.value);
    };

    _this.chartReference = React.createRef();
    _this.state = _this.getInitialState();
    return _this;
  }

  PricingGridChart.prototype.componentWillMount = function () {
    this.populateGraphData();
  };

  PricingGridChart.prototype.componentDidUpdate = function (prevProps, prevState, snapshot) {
    if (JSON.stringify(prevProps.gridData) !== JSON.stringify(this.props.gridData) || JSON.stringify(prevProps.headers) !== JSON.stringify(this.props.headers)) {
      this.populateGraphData();
    }
  };

  PricingGridChart.prototype.render = function () {
    var _this = this;

    var _a = this.state,
        chartData = _a.chartData,
        contracts = _a.contracts,
        initialContract = _a.initialContract,
        maximumPrice = _a.maximumPrice;
    var _b = this.props,
        pivotKeyColumn = _b.pivotKeyColumn,
        pivotKeyRow = _b.pivotKeyRow,
        priceMode = _b.priceMode,
        pricingGridChartType = _b.pricingGridChartType,
        selectedContract = _b.selectedContract,
        displayPriceAnalysisButton = _b.displayPriceAnalysisButton,
        parentService = _b.parentService;
    var options = {
      responsive: true,
      maintainAspectRatio: false,
      title: {
        display: true,
        text: pivotKeyColumn ? "" + capitalize(pivotKeyColumn) : ''
      },
      tooltips: {
        mode: 'point',
        callbacks: {
          title: function title(tooltipItem, data) {
            return capitalize(pivotKeyRow) + ": " + data.labels[tooltipItem[0].index];
          },
          label: function label(tooltipItems, data) {
            return data.datasets[tooltipItems.datasetIndex].label + ": " + tooltipItems.yLabel.toLocaleString(undefined, {
              style: 'currency',
              currency: data.datasets[tooltipItems.datasetIndex].currency[tooltipItems.index]
            });
          }
        }
      },
      hover: {
        mode: 'nearest',
        intersect: true
      },
      scales: {
        xAxes: [{
          display: true,
          scaleLabel: {
            display: true,
            labelString: capitalize(pivotKeyRow)
          },
          ticks: {
            callback: function callback(title) {
              var maxLabelLength = 15;
              if (title.length > maxLabelLength) return title.substr(0, maxLabelLength) + "...";
              return title;
            }
          }
        }],
        yAxes: [{
          display: true,
          scaleLabel: {
            display: true,
            labelString: priceMode === 'total' ? 'Total Price' : 'Price per Item'
          }
        }]
      },
      pan: {
        enabled: true,
        mode: 'xy',
        rangeMin: {
          x: 0,
          y: 0
        },
        rangeMax: {
          x: null,
          y: maximumPrice
        }
      },
      zoom: {
        enabled: true,
        mode: 'xy',
        rangeMin: {
          x: 0,
          y: 0
        },
        rangeMax: {
          x: null,
          y: maximumPrice
        },
        speed: 0.05
      }
    };
    var contractsOptions = [];

    if (pivotKeyColumn && contracts) {
      contractsOptions.push.apply(contractsOptions, __spread(contracts.CatalogPrice, contracts.Contracts));
    }

    if (!chartData || chartData.datasets.length === 0) {
      return emptyChart;
    }

    var chartSelectionDropdown = React.createElement("div", {
      className: "chart-selection-dropdown"
    }, React.createElement(FormControl, null, React.createElement(InputLabel, {
      id: "demo-simple-select-label",
      className: "chart-selection-dropdown-label"
    }, "Select Chart"), React.createElement(Select, {
      labelId: "demo-simple-select-label",
      id: "demo-simple-select",
      className: "chart-selection-dropdown-select",
      value: pricingGridChartType,
      onChange: this.onChartTypeChange
    }, React.createElement(MenuItem, {
      className: "chart-type-dropdown-item",
      value: "line"
    }, "Line"), React.createElement(MenuItem, {
      className: "chart-type-dropdown-item",
      value: "bar"
    }, "Bar"))));
    var contractSelectionDropdown = React.createElement("div", {
      className: "chart-contracts-dropdown"
    }, React.createElement(FormControl, null, React.createElement(InputLabel, {
      id: "demo-simple-select-label",
      className: "chart-contracts-dropdown-label"
    }, "Select Contract"), React.createElement(Select, {
      labelId: "demo-simple-select-label",
      className: "chart-contracts-dropdown-select",
      id: "demo-simple-select",
      value: selectedContract || initialContract,
      onChange: this.onContractChange
    }, contractsOptions.map(function (contract) {
      return React.createElement(MenuItem, {
        className: "contracts-dropdown-item",
        value: contract,
        key: contract
      }, contract);
    }))));
    var priceAnalysisLink = displayPriceAnalysisButton && !pivotKeyColumn && pivotKeyRow && pivotKeyRow.toLowerCase() === 'quantity' ? React.createElement("div", {
      className: "price-analysis-button"
    }, React.createElement("a", {
      onClick: function onClick() {
        _this.props.togglePriceAnalysis();
      }
    }, "Price Analysis")) : React.createElement("div", {
      className: "disabled-price-analysis-button"
    }, React.createElement("a", {
      className: "disabled-link"
    }, "Price Analysis"));
    var currentChart = pricingGridChartType === 'line' ? React.createElement(Line, {
      ref: this.chartReference,
      redraw: true,
      data: chartData,
      options: options
    }) : React.createElement(Bar, {
      ref: this.chartReference,
      redraw: true,
      data: chartData,
      options: options
    });

    if (!pivotKeyColumn) {
      return React.createElement("div", null, React.createElement("div", {
        className: "charts-nav-header-group"
      }, React.createElement("div", {
        className: "dropdown-group"
      }, chartSelectionDropdown), parentService === 'priceExplorer' ? priceAnalysisLink : null), React.createElement("div", {
        className: "single-pivot-chart-div"
      }, currentChart), React.createElement(Button, {
        type: "default",
        size: "sm",
        className: "reset-zoom-button",
        onClick: function onClick() {
          return _this.chartReference.current.chartInstance.resetZoom();
        }
      }, "Reset Zoom"));
    }

    return React.createElement("div", null, React.createElement("div", {
      className: "charts-nav-header-group"
    }, React.createElement("div", {
      className: "dropdown-group"
    }, chartSelectionDropdown, contractSelectionDropdown), parentService === 'priceExplorer' ? priceAnalysisLink : null), React.createElement("div", {
      className: "dual-pivot-chart-div"
    }, currentChart), React.createElement(Button, {
      type: "default",
      size: "sm",
      className: "reset-zoom-button",
      onClick: function onClick() {
        return _this.chartReference.current.chartInstance.resetZoom();
      }
    }, "Reset Zoom"));
  };

  return PricingGridChart;
}(Component);

export default PricingGridChart;